(ns minorodata.components.file-ingest.file-upload
  (:require [re-posh.core :as re-posh]
            [clojure.string]
            [react]
            [applied-science.js-interop :as js-interop]
            ["lucide-react" :refer [Upload]]
            ["react-dropzone" :refer [useDropzone]]
            [minorodata.app.handlers :refer [dispatch]]
            [minorodata.file-ingest.model :refer [->ingest-error]]
            [ui.button :refer [button]]
            [ui.typography :as typography]
            [ui.utils :refer [clsx]]
            [minorodata.components.file-ingest.modal :refer [error-modal]]))

(def accepted-file-types
  #{"xls" "xlsx" "csv"})

(defn reset-error []
  (re-posh/dispatch [:ingest-error/delete]))

(defn handle-files [files]
  (let [target-file (first files)
        target-size (js-interop/get target-file :size)
        target-name (js-interop/get target-file :name)
        target-ext  (-> (clojure.string/split target-name #"\.")
                        last)]

    (dispatch [:file-ingest.api/file-upload target-file])

    (cond
      (not (contains? accepted-file-types target-ext))
      (dispatch [:ingest-error/add
                 (-> {:step :upload-file
                      :msg  "File ingest only supports .csv, .xls and .xlsx files"}
                     ->ingest-error)])

      (>= target-size 10000e+6)
      (dispatch [:ingest-error/add
                 (-> {:step :upload-file
                      :msg  "The maximum upload file size is 10GB"}
                     ->ingest-error)])

      :else
     ;; if more than 0.1 megabyte, show a spinner
      (when (>= target-size 0.1e+6)
        (dispatch [:ingest-error/add
                   (-> {:step         :upload-file
                        :show-loader? true
                        :title        "Hang tight..."
                        :msg          "Processing a large file, it can take a while."}
                       ->ingest-error)])))))


(defn file-input [{:keys [get-root-props get-input-props open is-drag-active]}]
  [:div (->> (js->clj (get-root-props))
             (merge {:class    (clsx "cursor-pointer flex flex-col items-center gap-3 max-w-2xl mx-auto px-6 py-10 text-center rounded-lg border-2 border-dashed transition-colors hover:bg-kleene-hover-background focus:outline-hidden focus-visible:ring-3 focus-visible:ring-kleene-neutral-04/30"
                                     (if is-drag-active
                                       "border-kleene-secondary-01 bg-kleene-hover-background"
                                       "border-kleene-layout-border bg-kleene-background"))
                     :data-cy  "file-ingest-file-target"
                     :onClick (fn [_] (open))}))
   [:input (->> (js->clj (get-input-props))
                (merge {:data-cy "dropzone"}))]
   [:> Upload {:size  32
               :class "text-kleene-text-secondary"}]

   [typography/h3
    (if is-drag-active
      "Drop the file to upload"
      "Drag and drop a file here")]

   [button {:variant   :secondary
            :component :div}
    "Choose a file"]

   [typography/small {:class "text-kleene-text-secondary"}
    "CSV, XLS or XLSX"]])


(defn file-upload []
  (let [error    @(re-posh/subscribe [:ingest-error/pull])
        dropzone (useDropzone #js {:onDrop handle-files
                                   :noDragEventsBubbling true
                                   :noClick true
                                   :useFsAccessApi true})

        getRootProps  (js-interop/get dropzone :getRootProps)
        getInputProps (js-interop/get dropzone :getInputProps)
        isDragActive  (js-interop/get dropzone :isDragActive)
        open          (js-interop/get dropzone :open)]
    [:div
     [file-input {:get-root-props  getRootProps
                  :get-input-props getInputProps
                  :is-drag-active  isDragActive
                  :open            open}]
     [error-modal
      {:error                error
       :reset-error-callback reset-error}]]))
